import { connect } from "react-redux";

import SidebarBody from "./SidebarBody";
import NestedSidebar from "./NestedSidebar";
import { isStoreActive } from "../../../shared/utility";

export const Sidebar = (props) => {
  const { currentStore, user } = props;

  return (
    <div
      className={`sidebar sidebar-wrapper ${
        !isStoreActive(currentStore, user, true) && "store-inactive"
      }`}
    >
      <SidebarBody />
      <NestedSidebar />
    </div>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  user: state.authentication.user,
  currentStore: state.store.currentStore,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
